import { Platform, ViewStyle } from "react-native";
import type { PanelShadowStyle } from "./themes";

/** Hex #rrggbb oder #rgb zu rgba(r,g,b,a) mit gegebener Opacity */
function hexToRgba(hex: string, opacity: number): string {
  let r = 0,
    g = 0,
    b = 0;
  const h = hex.replace("#", "");
  if (h.length === 6) {
    r = parseInt(h.slice(0, 2), 16);
    g = parseInt(h.slice(2, 4), 16);
    b = parseInt(h.slice(4, 6), 16);
  } else if (h.length === 3) {
    r = parseInt(h[0] + h[0], 16);
    g = parseInt(h[1] + h[1], 16);
    b = parseInt(h[2] + h[2], 16);
  }
  return `rgba(${r},${g},${b},${opacity})`;
}

/** Konvertiert PanelShadowStyle in eine CSS boxShadow-String (für Web). */
export function toBoxShadow(s: PanelShadowStyle): string {
  const { shadowColor, shadowOffset, shadowOpacity, shadowRadius } = s;
  const color = hexToRgba(shadowColor, shadowOpacity);
  return `${shadowOffset.width}px ${shadowOffset.height}px ${shadowRadius}px ${color}`;
}

/** Wie PanelShadowStyle, aber mit optionalem elevation. */
export function getShadowStyle(
  style: Partial<PanelShadowStyle> | undefined
): ViewStyle {
  if (!style?.shadowColor) return {};
  const full = style as PanelShadowStyle;
  if (
    typeof full.shadowOffset?.width !== "number" ||
    typeof full.shadowOpacity !== "number" ||
    typeof full.shadowRadius !== "number"
  )
    return {};
  if (Platform.OS === "web") {
    return { boxShadow: toBoxShadow(full) };
  }
  return {
    shadowColor: full.shadowColor,
    shadowOffset: full.shadowOffset,
    shadowOpacity: full.shadowOpacity,
    shadowRadius: full.shadowRadius,
    elevation: full.elevation ?? 4,
  };
}
